var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectStartFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 21651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2459 21H19.2742C17.0677 21 15.26 22.3192 15.26 23.9295V29.0707C15.26 30.6809 17.0677 32.0002 19.2742 32.0002H58.2459C60.4523 32.0002 62.26 30.6809 62.26 29.0707V23.9295C62.26 22.3192 60.4523 21 58.2459 21Z",
    fill: "#44484E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2459 41H19.2742C17.0677 41 15.26 42.3192 15.26 43.9295V49.0707C15.26 50.6809 17.0677 52.0002 19.2742 52.0002H58.2459C60.4523 52.0002 62.26 50.6809 62.26 49.0707V43.9295C62.26 42.3192 60.4523 41 58.2459 41Z",
    fill: "#44484E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73999 2C1.73999 0.895431 2.63542 0 3.73999 0H47.6939C48.7985 0 49.6939 0.895431 49.6939 2V19H18.0442C15.748 19 13.8667 20.799 13.8667 22.9948V30.0054C13.8667 32.2012 15.748 34.0002 18.0442 34.0002H49.6939V39.0058H18.0442C15.748 39.0058 13.8667 40.8048 13.8667 43.0006V50.0113C13.8667 52.2071 15.748 54.0061 18.0442 54.0061H49.6939V62C49.6939 63.1046 48.7985 64 47.6939 64H3.73999C2.63542 64 1.73999 63.1046 1.73999 62V2Z",
    fill: "#44484E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectStartFeed);
export default __webpack_public_path__ + "static/media/ProjectStartFeed.3ab72398336c7b06cb959c204ecd9c04.svg";
export { ForwardRef as ReactComponent };